/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BADGE_TYPE_OUTLINE, Badge, BadgeProps } from '@squiz/sds';
import clsx from 'clsx';
import React from 'react';
import { InstanceStatusBadgeProps } from './InstanceStatusBadge.props';

/**
 * A <Badge /> to display the status of an instance.
 */
export const InstanceStatusBadge = (props: InstanceStatusBadgeProps): JSX.Element => {
  const { status } = props;
  const friendlyStatus = status.replace(/ /g, `-`).toLowerCase();
  const badgeClass = clsx(`status-badge--instance`, `instance--${friendlyStatus}`);

  const badgeProps: BadgeProps = {
    left: status,
    type: BADGE_TYPE_OUTLINE,
  };

  return (
    <div className={badgeClass}>
      <Badge {...badgeProps} />
    </div>
  );
};
